/* eslint-disable no-param-reassign */
import React from "react";
import { AuthProvider } from "./auth-context";
import { UserProvider } from "./user-context";
interface Props {
  children: React.ReactNode;
}

const AppProviders: React.FC<Props> = ({ children }) => {
  return (
    <AuthProvider>
      <UserProvider>{children}</UserProvider>
    </AuthProvider>
  );
};

export default AppProviders;
